const ROUTE = {
  KNOWLEDGE_BASE: 'knowledge',
  MATERIAL: 'material',
  QUESTIONS: 'questions',
}

export default ROUTE
